import { Grid } from '@material-ui/core';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { Async } from '../../../../components/AsyncProvider';
import { BackButton } from '../../../../components/BackButton';
import { Button } from '../../../../components/Button/index';
import { Input } from '../../../../components/Input';
import { Loading } from '../../../../components/Loading/index';
import { IAsyncData } from '../../../../models';
import { IApplicationState } from '../../../../store/models';
import { Container } from '../../../Layout/components/Container/index';
import { setFooterVisibility } from '../../../Layout/store/actions';
import { ContactActions } from '../../store/actions';

import './index.scss';

export type MessageForm = Record<EFieldName, string>;

enum EFieldName {
    NAME = 'first_name',
    SURNAME = 'last_name',
    MESSAGE = 'message',
}

export const SendMessage: React.FC = () => {
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm<MessageForm>();
    const sendMessageBranch = useSelector<IApplicationState, IAsyncData<void>>((state) => state.contact.sendMessage);
    const handleSubmitForm = (form: MessageForm) => {
        dispatch(ContactActions.sendMessage(form));
    };
    React.useEffect(
        () => {
            dispatch(setFooterVisibility(false));

            return () => {
                dispatch(setFooterVisibility(true));
                dispatch(ContactActions.sendMessageInitial());
            };
        },
        [dispatch],
    );

    return (
        <section id="send-message">
            <Container>
                <Grid container justify="center">
                    <Grid item sm={6} xs={12}>
                        <BackButton />
                        <Async
                            branch={sendMessageBranch}
                            deps={[]}
                            initialRender={() => (
                                <>
                                    <Input
                                        placeholder="Name"
                                        name={EFieldName.NAME}
                                        register={register({ required: true })}
                                    />
                                    <Input
                                        placeholder="Surname"
                                        name={EFieldName.SURNAME}
                                        register={register({ required: true })}
                                    />
                                    <Input
                                        placeholder="Message"
                                        name={EFieldName.MESSAGE}
                                        register={register({ required: true })}
                                    />
                                    <div className="send-message-submit">
                                        <Button onClick={handleSubmit(handleSubmitForm)}>Send Message</Button>
                                    </div>
                                </>
                            )}
                            loadingRender={() => <Loading />}
                            successRender={() => (
                                <div className="message">
                                    <h3>Thank You!</h3>
                                </div>
                            )}
                        />
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};
